import { SPONSORED_AGENT } from '@web-platform/shared-universal-constants/src/queryParams';
import { FEATURE_DECISION_KEYS } from '@web-platform/shared-universal-constants-config';
import { getFirstFilteredExploreAirline } from '@web-platform/shared-universal-redux/src/state/shared/adverts/combinedExplore/filteredExploreAirline/selectors';
import { getFeatureDecision } from '@web-platform/shared-universal-utils-frontend/src/config';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import type { State } from '@web-platform/shared-universal-types/src/redux/banana/state/state-banana-types';
import type { SearchState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

export const useExploreSponsoredAirlineFilter = ({ userSearch }: { userSearch: SearchState }) => {
  const navigate = useNavigate();
  const [currentSearchParams] = useSearchParams();
  const { sponsoredAgent, ...currentUserSearch } = userSearch;

  const exploreAirlineAd = useSelector((state: State) =>
    getFirstFilteredExploreAirline(state.shared.adverts.combinedExplore.filteredExploreAirline),
  );

  const exploreAirlineAdToShow = getFeatureDecision(
    FEATURE_DECISION_KEYS.ENABLE_EXPLORE_SPONSORED_CONTENT,
  )
    ? exploreAirlineAd
    : null;

  const partnerId = exploreAirlineAd?.creative.partnerId;

  const isExploreFilterActive = !!sponsoredAgent;

  const handleExploreFilterToggle = (isEnabled: boolean) => {
    if (!partnerId) {
      return;
    }

    const updatedSponsoredAgent = isEnabled ? partnerId : undefined;
    const searchParams = new URLSearchParams(currentSearchParams);

    const updatedUserSearch = {
      ...currentUserSearch,
      sponsoredAgent: updatedSponsoredAgent,
    };

    if (updatedSponsoredAgent) {
      searchParams.set(SPONSORED_AGENT, updatedSponsoredAgent);
    } else {
      searchParams.delete(SPONSORED_AGENT);
    }

    navigate(`?${searchParams.toString()}`, {
      replace: true,
      state: { searchParams: updatedUserSearch },
    });
  };

  return {
    exploreAirlineAd: exploreAirlineAdToShow,
    isExploreFilterActive,
    handleExploreFilterToggle,
  };
};
